import React from 'react';
import PropTypes from 'prop-types';
import { Loading } from '@folio/stripes-components';
import { groupBy } from 'lodash';
import FieldsList from '../../../FieldsList';
import useCustomFields from '../../../../hooks/useCustomFields';

function CustomFieldsList({ parentFields, fieldArrayName }) {
  const { customFields, isLoading } = useCustomFields();

  const groupedFields = groupBy(customFields, 'entityType');

  const entityTypes = {
    instance: groupedFields.instance,
    holdings: groupedFields.holding,
    items: groupedFields.item,
  };
  const customFieldsScheme = entityTypes[fieldArrayName] || [];

  return (
    <>
      {isLoading && <Loading />}
      {!isLoading && (
        <FieldsList
          contentData={customFieldsScheme}
          schema="customField"
          parentFields={parentFields}
        />
      )}
    </>
  );
}

CustomFieldsList.propTypes = {
  parentFields: PropTypes.object,
  fieldArrayName: PropTypes.string,
};

export default CustomFieldsList;
